import {useCallback} from "react";

import {NavigationAmplitudeSource, NavigationAmplitudeTracker} from "../../tracking/amplitude/navigation_amplitude_tracker";
import {INavigationSection} from "../config/navigation_sections";

export const useTrackNavigationSection = (source: NavigationAmplitudeSource) => {
    return useCallback(
        (section: INavigationSection) => {
            const selectedTab = source === NavigationAmplitudeSource.MOBILE_BOTTOM_NAV ? section.labels.bottomNav : section.labels.sidebar;

            NavigationAmplitudeTracker.selectMenuSection({selectedTab});
        },
        [source]
    );
};
import {useCallback} from "react";

import {NavigationAmplitudeSource, NavigationAmplitudeTracker} from "../../tracking/amplitude/navigation_amplitude_tracker";
import {INavigationSection} from "../config/navigation_sections";

export const useTrackNavigationSection = (source: NavigationAmplitudeSource) => {
    return useCallback(
        (section: INavigationSection) => {
            const selectedTab = source === NavigationAmplitudeSource.MOBILE_BOTTOM_NAV ? section.labels.bottomNav : section.labels.sidebar;

            NavigationAmplitudeTracker.selectMenuSection({selectedTab});
        },
        [source]
    );
};
